module.exports = __webpack_public_path__ + "static/desktop-hero-93409aeb82003d05206c31926138984d.jpg";